import React, { useState } from "react";

import RegisterPassword from "./registerPassword";
import Approval from "./approval";

export default (props) => {
  const adminId = props.match.params.id;
  const [step, setStep] = useState(0);

  switch (step) {
    case 0:
      return <RegisterPassword setStep={setStep} adminId={adminId} />;
    case 1:
      return <Approval />;
    default:
      return <></>;
  }
};
